/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

class ProductFeaturedPlaceholder extends Component {

	render() {
		const {
			design = 'style-v1',
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showAddToCart = true,
			showCompare = true,
			showWishlist = true,
		} = this.props

		const output = (
			<div className={ classnames( [
				'd-flex',
				'h-100',
				'mb-6',
			], { 'mx-1' : design === 'style-v2' } ) }>
				<div className={ classnames( [ 'product bookwormgb-product-featured-placeholder w-100' ], { 'product__space mb-2 mb-lg-0 bg-white h-100' : design === 'style-v2', 'border-bottom border-right' : design === 'style-v1' } ) }>
					<div className={ classnames( [ 'product__inner overflow-hidden' ], { 'p-3 p-md-4d875' : design === 'style-v1', 'd-flex py-5 py-md-6 py-lg-8 px-3 px-md-4 px-lg-6 px-xl-8 h-100' : design === 'style-v2' } ) }>
						<div className="d-block position-relative w-100">
							{ showImage &&
								<div className={ classnames( [ 'progress bg-light' ], { 'mb-2' : design === 'style-v1', 'mb-5 mb-xl-8' : design === 'style-v2' } ) } style={ { height:'400px' } }></div>
							}
							{ showProductFormat &&
								<div className="badge badge-shadow w-50">
									<div className="progress bg-light"></div>
								</div>
							}
							{ showProductTitle &&
								<div className="badge badge-shadow w-80">
									<div className="progress bg-light"></div>
								</div>
							}
							{ showProductAuthor &&
								<div className="badge badge-shadow w-50 d-block">
									<div className="progress bg-light"></div>
								</div>
							}
							{ showProductPrice &&
								<div className="badge badge-shadow w-50">
									<div className="progress bg-light"></div>
								</div>
							}
							{ ( showAddToCart || showCompare || showWishlist ) &&
								<div className="d-flex align-items-center">
									{ showAddToCart &&
										<div className="badge badge-shadow mr-3" style={ { width:'150px', height: '30px' } }>
											<div className="progress bg-light"></div>
										</div>
									}
									{ showCompare &&
										<div className="progress bg-light rounded-pill mr-2" style={ { width:'30px', height: '30px' } }></div>
									}
									{ showWishlist &&
										<div className="progress bg-light rounded-pill" style={ { width:'30px', height: '30px' } }></div>
									}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		)

		return output
	}
}

export default ProductFeaturedPlaceholder